import { ArrowDownAZ, ChevronLeftIcon, Funnel, SearchIcon, XIcon } from "lucide-react";
// @ts-ignore
import profileImg from '@assets/images/profilepic.png'
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { setJobDetail } from "@store/actions/job.action";
import dayjs from "@lib/dayjs";
import { EnumJobStatus2, JobStatus } from "@utils/constants";
import AnimatedCircleProgress from "@components/AnimatedCircleProgress";
import { recruiterCandidateAppliedJobs } from "@endpoints/job.service";
import { useEffect, useState } from "react";
import { useDebounce } from "hooks/useDebounce";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@components/ui/dropdown-menu";

export function getStatusColors({ status }: { status: EnumJobStatus2 }) {
    switch (status) {
        case EnumJobStatus2.LIVE:
            return 'border-[#99CA60]'
        case EnumJobStatus2.EXPIRED:
            return 'border-[#6f6f6f]'
        default:
            return 'border-black'
    }
}

export function getStatusTextColors({ status }: { status: EnumJobStatus2 }) {
    switch (status) {
        case EnumJobStatus2.LIVE:
            return 'text-[#99CA60]'
        case EnumJobStatus2.EXPIRED:
            return 'text-[#6f6f6f]'
        default:
            return 'text-black'
    }
}

enum EnumSortOrder {
    HIGHEST = "highest",
    LOWEST = "lowest",
}

enum EnumSortBy {
    MOST_LATEST_ACTIVITY = "mostLatestActivity",
    MATCHING_PERCENTAGE = "matchingPercentage",
    LIVE = "live",
    EXPIRED = "expired",
}

const sortByFilters = [
    { label: "Most Latest Activity", value: EnumSortBy.MOST_LATEST_ACTIVITY },
    { label: "Matching Percentage", value: EnumSortBy.MATCHING_PERCENTAGE },
    { label: "Live", value: EnumSortBy.LIVE },
    { label: "Expired", value: EnumSortBy.EXPIRED },
];

const sortOrderFilters = [
    { label: "Highest", value: EnumSortOrder.HIGHEST },
    { label: "Lowest", value: EnumSortOrder.LOWEST },
];

const JobCard = ({ data }) => {
    const dispatch = useDispatch();
    const isClosed = data?.status === JobStatus.CLOSED && "Closed";
    console.log('this is datas', data)

    return (
        <NavLink
            to={`/job-applicant-detail`}
            // onClick={() => {
            //     dispatch(setJobDetail(data));
            //     // navigate(`/job/${data?._id}/applicants`, { state: data });
            // }}
            state={{
                item: {
                    ...data,
                    _id: data?.jobApplicationId,
                }
            }}
            className="grid grid-cols-[1.4fr_1.3fr_0.2fr] gap-12 justify-between bg-white border-b border-[#ececec] rounded px-3 py-5 hover:bg-slate-100 cursor-pointer"
        >
            <div className="flex flex-col gap-1">
                <div className="flex items-center justify-between">
                    <span className="text-[10px] text-light-black font-medium pl-2">
                        {data?.refNo}
                    </span>
                    <span className={`flex justify-center items-center font-medium text-[10px] ${getStatusTextColors({ status: data?.status })}`}> {data?.status === JobStatus.LIVE && "Live"}
                        {data?.status === JobStatus.DRAFT && "Draft"}
                        {data?.status === JobStatus.UNPUBLISHED && "Unpublished"}
                        {data?.status === JobStatus.CLOSED && "Closed"}
                        {data?.status === JobStatus.EXPIRED && "Expired"}
                    </span>
                </div>
                <div className={`flex flex-col gap-1 rounded-md py-3 px-5 border border-y-gray-100 border-r-gray-100 ${getStatusColors({ status: data?.status })} border-l-[3px]`}>
                    <span className="text-xs font-bold text-charcoal line-clamp-1">{data?.title}</span>
                    <span className="text-xss font-medium text-light-black">Hiring Company:&nbsp;&nbsp;&nbsp;<span className="font-medium text-charcoal">{data?.hiringCompany?.companyName || 'N/A'}</span></span>
                </div>
                {data?.publishedDate ? (
                    <div className="flex items-center justify-between pl-2">
                        <div className="flex items-center gap-2">
                            <span className="text-[10px] text-gray-400 font-medium">
                                Published:
                            </span>
                            <span className="text-[10px] text-charcoal italic font-medium">
                                {dayjs(data?.publishedDate).format("hh:mm a Do MMM YY")}
                            </span>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="text-[10px] text-gray-400 font-medium">
                                {isClosed ? "Closed" : "Expiring"}:
                            </span>
                            <span className="text-[10px] text-charcoal italic font-medium">
                                {dayjs(isClosed ? data?.updatedAt : data?.expiredAt).format(
                                    "hh:mm a Do MMM YY"
                                )}
                            </span>
                        </div>
                    </div>
                ) : null}
            </div>

            <div className="flex flex-col gap-1">
                <div className="flex items-center gap-5 h-[1rem]">
                    {
                        data?.latestTracker?.createdAt ?
                            <>
                                <span className="text-xss text-light-black font-medium italic">
                                    {dayjs(data?.latestTracker?.createdAt).format("hh:mm a")}
                                </span>
                                <span className="text-xss text-light-black font-medium italic">
                                    {dayjs(data?.latestTracker?.createdAt).format("DD MMM YYYY")}
                                </span>
                            </>
                            :
                            null
                    }
                </div>

                <div className="flex items-center bg-light-white-700 border border-gray-200 rounded-md h-[3.8rem] py-3 px-3">
                    <span className="text-xs font-medium text-charcoal">
                        Latest Activity : {data?.latestTracker?.status || 'N/A'}
                    </span>
                </div>
            </div>

            <div className="flex flex-col text-xss gap-2">
                Matched
                <div className="relative">
                    <AnimatedCircleProgress
                        progress={data?.matchingPercentage || 0}
                        strokeWidth={2}
                        textStyle="font-semibold text-charcoal"
                    />
                </div>
            </div>
        </NavLink>
    );
};

const CandidateAppliedJobPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const candidateId = location?.state?.candidateId;
    const candidateFromState = location?.state?.candidate || null;
    const [candidate, setCandidate] = useState(candidateFromState);
    const [jobs, setJobs] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [filters, setFilters] = useState({
        searchText: "",
        sortBy: sortByFilters[0],
        sortOrder: null as null | { label: string; value: EnumSortOrder },
    });
    const debouncedSearchText = useDebounce(filters?.searchText, 500);
    const isSortOrderDisabled = filters?.sortBy?.value === EnumSortBy.MOST_LATEST_ACTIVITY;

    useEffect(() => {
        setFilters((prev) => {
            if (prev.sortBy?.value === EnumSortBy.MOST_LATEST_ACTIVITY) {
                return { ...prev, sortOrder: null };
            }

            if (!prev.sortOrder) {
                return { ...prev, sortOrder: sortOrderFilters[0] };
            }

            return prev;
        });
    }, [filters?.sortBy?.value]);

    useEffect(() => {
        const fetchAppliedJobs = async () => {
            if (!candidateId) return;
            try {
                setIsLoading(true);
                const { data, success } = await recruiterCandidateAppliedJobs(candidateId, {
                    sortBy: filters?.sortBy?.value,
                    sortOrder: filters?.sortOrder?.value,
                    searchText: debouncedSearchText,
                });
                if (success) {
                    setCandidate(data?.candidate || candidateFromState);
                    setJobs(data?.jobs || []);
                }
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        };
        fetchAppliedJobs();
    }, [candidateId, filters?.sortBy, filters?.sortOrder, debouncedSearchText]);

    return <div className="flex flex-col flex-1 rounded-md bg-white p-5 min-h-0">
        <button
            onClick={() => navigate('/job/by-candidate')}
            className="flex items-center self-start gap-1"
        >
            <ChevronLeftIcon className={"w-4 h-4"} />
            <label className="text-xs font-medium text-charcoal cursor-pointer">
                Back to listing
            </label>
        </button>

        {!candidateId ? (
            <div className="flex flex-1 items-center justify-center text-sm text-light-black">
                Candidate not found.
            </div>
        ) : (
            <div className="flex flex-col px-4 min-h-0 flex-1">
                <div className="flex items-center gap-7 bg-[#fafafa] mt-5 border  py-3 px-5">
                    <div className="h-[64px] w-[64px] rounded-full flex items-center justify-center overflow-hidden border-2">
                        {candidate?.profilePic ?
                            <img src={candidate?.profilePic || profileImg} className="object-cover bg-black" />
                            :
                            <span className="font-bold text-charcoal text-xl">{candidate?.firstName?.charAt(0)}{candidate?.lastName?.charAt(0)}</span>
                        }
                    </div>
                    <div className="flex flex-col gap-1.5 text-[#4d4d4d]">
                        <span className="border-b-[1px] border-primary text-lg font-medium tracking-[0.25rem] w-max pr-3">
                            {`${candidate?.firstName || ""} ${candidate?.lastName || ""}`.trim() || "-"}
                        </span>
                        <span className="text-xs font-medium">{candidate?.jobTitle || "-"}</span>
                    </div>
                </div>

                {/* Main section */}
                <div className="flex flex-col py-3.5 px-3 min-h-0 flex-1 overflow-hidden">
                    {/* Search sections */}
                    <div className="flex items-center gap-10 border-b pb-4">
                        <div className="flex items-center border rounded-md px-3 h-9 bg-light-white-700">
                            <input
                                className="outline-none text-xs font-medium bg-transparent w-48"
                                placeholder="Search"
                                value={filters?.searchText}
                                onChange={(e) => setFilters((prev) => ({ ...prev, searchText: e.target.value }))}
                            />
                            <SearchIcon color="gray" size={14} />
                        </div>

                        <DropdownMenu>
                            <div className="relative">
                                <DropdownMenuTrigger className="flex items-center text-charcoal font-semibold text-xs border rounded-md h-9 gap-1 px-3 outline-none w-64">
                                    <Funnel size={15} />
                                    Sort By : <span className="text-light-black">{filters?.sortBy?.label}</span>
                                </DropdownMenuTrigger>
                                {filters?.sortBy?.value !== sortByFilters[0]?.value ? (
                                    <button
                                        onClick={() => setFilters((prev) => ({ ...prev, sortBy: sortByFilters[0] }))}
                                        className="bg-red-500 rounded-full p-px absolute -top-2 -right-2 hover:scale-125"
                                    >
                                        <XIcon color="white" size={13} strokeWidth={2.5} />
                                    </button>
                                ) : null}
                            </div>
                            <DropdownMenuContent className="bg-white" align="start">
                                <div className="flex flex-col gap-2 px-2 py-3">
                                    <span className="text-xs mb-1">Sort By</span>
                                    {sortByFilters?.map((filter) => {
                                        const isSelected = filter?.value === filters?.sortBy?.value;
                                        return (
                                            <DropdownMenuItem
                                                key={filter?.value}
                                                className="flex gap-3 text-xs outline-none font-medium hover:cursor-pointer hover:bg-gray-50"
                                                onSelect={() => setFilters((prev) => ({ ...prev, sortBy: filter }))}
                                            >
                                                <div className="flex w-4 h-4 rounded-full border border-primary">
                                                    {isSelected ? <div className="w-2.5 h-2.5 bg-primary rounded-full m-auto" /> : null}
                                                </div>
                                                {filter?.label}
                                            </DropdownMenuItem>
                                        );
                                    })}
                                </div>
                            </DropdownMenuContent>
                        </DropdownMenu>

                        <DropdownMenu>
                            <div className="relative">
                                <DropdownMenuTrigger
                                    disabled={isSortOrderDisabled}
                                    className={`flex items-center text-charcoal font-semibold text-xs border rounded-md h-9 gap-1 px-3 outline-none w-52 ${isSortOrderDisabled ? "opacity-50 cursor-not-allowed" : ""
                                        }`}
                                >
                                    <ArrowDownAZ size={15} />
                                    Sort Order : <span className="text-light-black">{filters?.sortOrder?.label || "Select"}</span>
                                </DropdownMenuTrigger>
                                {!isSortOrderDisabled && filters?.sortOrder ? (
                                    <button
                                        onClick={() => setFilters((prev) => ({ ...prev, sortOrder: null }))}
                                        className="bg-red-500 rounded-full p-px absolute -top-2 -right-2 hover:scale-125"
                                    >
                                        <XIcon color="white" size={13} strokeWidth={2.5} />
                                    </button>
                                ) : null}
                            </div>
                            <DropdownMenuContent className="bg-white" align="start">
                                <div className="flex flex-col gap-2 px-2 pt-3">
                                    <span className="text-xs mb-1">Filter By</span>
                                    {sortOrderFilters?.map((filter) => {
                                        const isSelected = filter?.value === filters?.sortOrder?.value;
                                        return (
                                            <DropdownMenuItem
                                                key={filter?.value}
                                                className="flex gap-3 text-xs outline-none hover:cursor-pointer hover:bg-gray-50"
                                                onSelect={() => setFilters((prev) => ({ ...prev, sortOrder: filter }))}
                                            >
                                                <div className="flex w-4 h-4 rounded-full border border-primary">
                                                    {isSelected ? <div className="w-2.5 h-2.5 bg-primary rounded-full m-auto" /> : null}
                                                </div>
                                                {filter?.label}
                                            </DropdownMenuItem>
                                        );
                                    })}
                                </div>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>

                    {/* Listing section  */}
                    <div className="flex flex-col min-h-0 flex-1 overflow-y-auto no-scrollbar">
                        {
                            isLoading ? (
                                <div className="py-6 mx-auto">
                                    <LoadingAnimation color="black" />
                                </div>
                            ) : jobs?.length ? (
                                jobs?.map((job) => {
                                    return <JobCard
                                        key={job?.jobId}
                                        data={{
                                            ...job,
                                            _id: job?.jobId,
                                            expiredAt: job?.expiryDate,
                                            latestTracker: job?.latestTracker,
                                        }}
                                    />
                                })
                            ) : (
                                <div className="py-6 text-center text-sm text-light-black">
                                    No applied jobs found.
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        )}
    </div>
}

export default CandidateAppliedJobPage;





